import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { reopenRecognition } from 'api/recognitions.service';
import { useToast } from 'hooks/ui';
import { useApplicationStore } from 'store/application';
import { setDraftRecognition } from 'store/recognition';
import { recognitionKeys } from './queryKeys';

export const useRecognitionReopenQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { setLoading, removeLoading } = useApplicationStore();

  const { isPending, mutate } = useMutation({
    mutationFn: (id: string) => {
      setLoading();

      return reopenRecognition(id);
    },
    onSuccess: (recognition) => {
      toast.success('Recognition has been reopened successfully');
      setDraftRecognition(recognition);
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: recognitionKeys.all });
      removeLoading();
    },
  });

  return { isLoading: isPending, mutate };
};
